import { fromJS } from "immutable";
import * as types from "../constants";
import newSubscriber from "./template/new_subscriber.json";
import newCustomers from "./template/new_customers.json";
import finishOrder from "./template/finish_order.json";
import newOrder from "./template/new_order.json";

import imagenewCustomers from "../assets/images/template/new_custome.png";
import imageNewSubscriber from "../assets/images/template/new_subscriber1.png";
import imagefinishOrder from "../assets/images/template/finishOrder2.png";
import imageNewOrder from "../assets/images/template/new_order2.png";

const newSubscribertTemplate = {
  id: -2,
  title: `Newsletter subscribers`,
  image: imageNewSubscriber,
  description: `Newsletter subscribers`,
  template_type: "newsletters",
  template: JSON.stringify(newSubscriber),
};

const newCustomersTemplate = {
  id: -3,
  title: `New customers`,
  image: imagenewCustomers,
  description: `New customers`,
  template_type: "new_customers",
  template: JSON.stringify(newCustomers),
};
const finishOrderTemplate = {
  id: -4,
  title: `Fulfilled order Template`,
  image: imagefinishOrder,
  description: `Fulfilled orders`,
  template_type: "finish_order",
  template: JSON.stringify(finishOrder),
};
const newOrderTemplate = {
  id: -5,
  title: `New order Template`,
  image: imageNewOrder,
  description: `New orders`,
  template_type: "new_order",
  template: JSON.stringify(newOrder),
};

const defaultListTemplate = [
  newSubscribertTemplate,
  newCustomersTemplate,
  finishOrderTemplate,
  newOrderTemplate,
];

const defaultCampaign = {
  campaign_name: "",
  time_to_send: 0,
  from_name: "",
  from_admin: "",
  subject: "",
  repply_to: "",
  campaign_type: "",
};

const defaultState = fromJS({
  listCampaign: false,
  templates: defaultListTemplate,
  isSaveCampaign: null,
  isDeleteCampaign: null,
  dataDesignSelected: null,
  dataHtmlSelected: null,
  dataCampaignId: null,
  isActiveDisableCampaign: null,
  shopEmail: "",
  sendTest: null,
  listTemplateCampaign: [],
  campaignType: "",
  campaignData: fromJS(defaultCampaign),
  loading: false,
  isSaverBar: false,
});

const campaignReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CLOSE_SAVER_BAR_SETTINGS:
      console.log("action.data");
      console.log(action.value);
      return state.set("isSaverBar", action.value);
    case types.SAVER_SETTING_CAMPAIGN_RESPONSE:
      if (action.data && action.data.id) {
        state.setIn(["campaignData", "id"], action.data.id);
      }
      return state
        .set("isSaverBar", false)
        .set("isSaveCampaign", action.data && action.data.success);
    case types.GET_CAMPAIGN_DATA_RESPONSE:
      if (action.data) {
        return state
          .set("campaignData", fromJS(action.data))
          .set("campaignDesign", action.data.data_design_selected);
      }
      return state;
    case types.CHANGE_CAMPAIGN_DATA:
      return state
        .setIn(["campaignData", action.payload.field], action.payload.value)
        .set("isSaverBar", true)
        .set("isSaveCampaign", null);

    case types.GET_LIST_TEMPLATE_RESPONSE:
      if (action.data) {
        return state.set("listTemplateUser", action.data);
      }
      return state;
    case types.DATA_DESIGN_SELECTED_RESPONSE:
      if (action.data) {
        return state.set(
          "dataHtmlSelected",
          fromJS(action.data.data_html_selected),
        );
      }
      return state;
    case types.ACTIVE_DISABLE_CAMPAIGN_RESPONSE:
      return state.set(
        "isActiveDisableCampaign",
        action.data && action.data.success,
      );

    case types.DELETE_CAMPAIGN_RESPONSE:
      return state.set("isDeleteCampaign", action.data && action.data.success);
    case "UPDATE_FIELD_LIST_CAMPAIGN":
      return state.setIn(
        ["listCampaign", action.index, action.field],
        action.value,
      );
    case "RESPONSE_DATA_DESIGN_SELECTED":
      return state
        .set(
          "dataDesignSelected",
          (action.data && action.data.data_design_selected) || null,
        )
        .set(
          "dataHtmlSelected",
          (action.data && action.data.data_html_selected) || null,
        )
        .set("dataCampaignId", action.data || null);
    case "SEND_TEST_EMAIL_RESPONSE":
      return state.set("sendStatus", action.data || null);
    case types.GET_LIST_CAMPAIGN_BY_TYPE_RESPONSE:
      return state.set("listCampaign", action.data || false);

    default:
      return state;
  }
};

export default campaignReducer;
